import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { configProperties } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  configUrl = configProperties.configPath;
  private configSettings: any = null;

  constructor(
    private http: HttpClient
  ) {}

  get GSuiteClientID() {
    return this.configSettings.gsuite_client_id;    
  }

  get settings() {
    return this.configSettings;
  }

  public load(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(this.configUrl).subscribe((response: any) => {
        this.configSettings = response;
        const apiKeyReCaptcha = this.configSettings.recaptcha_key;

        if (apiKeyReCaptcha) {
          // Validar que la API key tenga un formato seguro (solo alfanumérico y guiones)
          const isValidApiKey = /^[a-zA-Z0-9_-]+$/.test(apiKeyReCaptcha);
          if (!isValidApiKey) {
            console.error("Invalid reCAPTCHA API key format.");
            reject(false);
            return;
          }
          
          // Construir la URL solo con el dominio permitido de Google
          const scriptUrl = `https://www.google.com/recaptcha/enterprise.js?render=${apiKeyReCaptcha}`;
          
          // Validar que la URL construida sea realmente de Google
          if (!scriptUrl.startsWith('https://www.google.com/recaptcha/')) {
            console.error("Invalid reCAPTCHA URL.");
            reject(false);
            return;
          }
          
          // Usar directamente la URL validada (no se necesita bypassSecurityTrustResourceUrl
          // porque document.createElement no pasa por la sanitización de Angular)
          const scriptElement = document.createElement('script');
          scriptElement.src = scriptUrl;
          scriptElement.async = true;
          scriptElement.defer = true;
          document.head.appendChild(scriptElement);
          scriptElement.onload = () => {
            resolve(true);
          };
          scriptElement.onerror = () => {
            console.error("Failed to load reCAPTCHA script.");
            reject(false);
          };
        } else {
          console.error("Key reCAPTCHA not found.");
        }

        resolve(true);
      });
    });
  }
}
